document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-input");
  const searchResults = document.getElementById("search-results");

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();
    if (query.length < 2) {
      searchResults.innerHTML = "";
      searchResults.style.display = "none";
      return;
    }

    fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
      .then((response) => response.json())
      .then((data) => {
        let resultsHtml = "";
        if (data.resources.results.products.length > 0) {
          resultsHtml = "<ul>";
          data.resources.results.products.forEach((product) => {
            resultsHtml += `
              <li>
                <a href="${product.url}">
                  <img src="${product.image}" alt="${product.title}" width="40" height="40">
                  ${product.title}
                </a>
              </li>
            `;
          });
          resultsHtml += "</ul>";
        } else {
          resultsHtml = "<p>No results found</p>";
        }

        searchResults.innerHTML = resultsHtml;
        searchResults.style.display = "block";
      })
      .catch((error) => console.error("Error fetching search results:", error));
  });

  // Hide results when clicking outside
  document.addEventListener("click", function (event) {
    if (!searchInput.contains(event.target) && !searchResults.contains(event.target)) {
      searchResults.style.display = "none";
    }
  });
});
